import { BoardColumnStructureProperty } from "./board-column-structure-property.model"

export class BoardColumnStructure implements BoardColumnStructureProperty {

    constructor() {
    }

    name: string = ''
    isSelected: boolean = true //indica se mostrare di default la colonna
    isSelectable: boolean = true //indica se mostrare il checkbox per nascondere-mostrare la colonna
    isEditable: boolean = true //indica se mostrare la colonna nell'elenco delle colonne modificabili
    isFixed: boolean = false // indica se la colonna non e' spostabile
    isSortable: boolean = false //indica se è sortabile

    static fromConfiguration(i: any) {
        let structure = new BoardColumnStructure()

        structure.name = i.name
        structure.isSelected = i.isSelected ?? structure.isSelected
        structure.isSelectable = i.isSelectable ?? structure.isSelectable
        structure.isEditable = i.isEditable ?? structure.isEditable
        structure.isFixed = i.isFixed ?? structure.isFixed
        structure.isSortable = i.isSortable ?? structure.isSortable

        return structure
    }

    mergeWithProperty(property: BoardColumnStructureProperty) {
        this.isSelected = property.isSelected
        return this
    }
}